// src/api/inventory.ts
import { apiRequest } from "../utils/apiClient"; // Adjust the path as needed

export const fetchInventoryData = async () => {
  // const response = await apiRequest("/api/inventory/dcList", "POST");
  const response = await apiRequest("/api/inventory/storeList", "POST");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const fetchStoreInventory = async () => {
  const response = await apiRequest("/api/inventory/storeList", "POST");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const fetchProductList = async (Search: string) => {
  const response = await apiRequest("/api/products/productList", "POST", {
    Search,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const fetchProductListAdmin = async (
  Search: string,
  page?: number,
  limit?: number,
) => {
  const response = await apiRequest("/api/products/productListAdmin", "POST", {
    Search,
    page,
    limit,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
export const submitRequest = async (items: any, store_id: string) => {
  const response = await apiRequest("/api/transfers/requestTransfer", "POST", {
    items: items,
    store_id: store_id,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const submitStoreRequest = async (
  items: any,
  store_id: string,
  receiving_store: string,
) => {
  const response = await apiRequest(
    "/api/transfers/requestStoreTransfer",
    "POST",
    {
      items: items,
      store_id: store_id,
      receiving_store: receiving_store,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }
  return response.data;
};

export const submitClientRequest = async (
  items: any,
  store_id: string,
  receiving_store: string,
) => {
  const response = await apiRequest(
    "/api/transfers/requestClientTransfer",
    "POST",
    {
      items: items,
      store_id: store_id,
      receiving_store: receiving_store,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }
  return response.data;
};

export const fetchStoreList = async (type: string) => {
  const response = await apiRequest("/api/stores/list", "POST", { type });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const fetchAllStores = async () => {
  const response = await apiRequest("/api/stores/all", "POST");

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const transferList = async (filter: any) => {
  const response = await apiRequest("/api/transfers/list", "POST", {
    filter,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const StoreTransferHistoryList = async (filter: any) => {
  const response = await apiRequest(
    "/api/transfers/storeOrderHistory",
    "POST",
    {
      filter,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const StoreTransferList = async (filter: any) => {
  const response = await apiRequest("/api/transfers/trList", "POST", {
    filter,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const ClientTransferList = async (filter: any, page?: number) => {
  const response = await apiRequest("/api/transfers/clientTrList", "POST", {
    filter,
    page,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const updateRequest = async (item: any) => {
  const response = await apiRequest(`/api/transfers/update`, "POST", {
    ...item,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

// for requested_qty_packed and requested_qty_unpacked
export const updateStoreRequest = async (item: any) => {
  const response = await apiRequest(
    `/api/transfers/updateStoreTransfer`,
    "POST",
    {
      ...item,
    },
  );
  console.log("updateStoreRequest response:", item);
  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
export const updateMultipleRequest = async (
  item: any,
  invoice_no: string,
  sending_store: string,
  requested_by: string,
) => {
  const response = await apiRequest(`/api/transfers/updateMultiple`, "POST", {
    ...item,
    invoice_no,
    sending_store,
    requested_by,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const approveRequest = async (items: any) => {
  const response = await apiRequest(
    `/api/transfers/approveMulipleTransfer`,
    "POST",
    {
      items,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
export const approveStoreRequest = async (invoiceNo: string) => {
  const response = await apiRequest(
    `/api/transfers/approveStoreRequest`,
    "POST",
    {
      invoice_no: invoiceNo,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const rejectRequest = async (items: any) => {
  const response = await apiRequest(
    `/api/transfers/rejectMulipleTransfer`,
    "POST",
    {
      items,
    },
  );

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const updateProduct = async (product: any) => {
  const response = await apiRequest("/api/products/update", "POST", {
    product,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const addProduct = async (product: any) => {
  const response = await apiRequest("/api/products/create", "POST", {
    ...product,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const updateStore = async (store: any) => {
  const response = await apiRequest("/api/stores/update", "POST", {
    store,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const addStore = async (store: any) => {
  const response = await apiRequest("/api/stores/create", "POST", {
    store,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response;
};

export const deleteStore = async (store_id: string) => {
  const response = await apiRequest("/api/stores/delete", "POST", {
    store_id,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const deleteProduct = async (product_id: string) => {
  const response = await apiRequest("/api/products/deleteProduct", "POST", {
    product_id,
  });

  if (response.status !== 200) {
    alert("Can not delete this product.");
    throw new Error(response.message);
  }
  return response.data;
};
